export default {
    defaultSettings: {
        version: 'V4.1.6.4',
        copyrightYear: '2024',
        environment: {
            ui: {
                appLogoLoading: require('../assets/img/logo-loading.png'),
                logoFull: require('../assets/img/logo.png'),
                logoFullWidth: '120px',
                logoMinimized: require('../assets/img/logo-minimized.png'),
                logoLoading: '',
                logoLoadingWidth: '150px',
                logoLoadingAnimationClass: 'blinker',
                login: {
                    primaryBGColor: '#FFFFFF',
                    primaryTextColor: '#2D2D2D',
                    primaryBorderColor: '#DDDDDD',
                    secondaryBGColor: '#D93838',
                    secondaryTextColor: '#FFFFFF',
                    secondaryBorderColor: '#D93838',
                    loginButtonTextColor: '#FFFFFF',
                    loginButtonBGColor: '#D93838',
                    loginButtonBorderColor: '#D93838',
                    registerButtonTextColor: '#FFFFFF',
                    registerButtonBGColor: '#D93838',
                    registerButtonBorderColor: '#FFFFFF'
                }
            }
        },
        theme: 'normalMode',
        lang: 'fr-CA'
    }
}